import React, { useState } from "react";
import { HiX } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import routes from "../../routes";
import logo from "../../assets/logos/Logo2.png";
import "./Sidebar.css";

const AdminSidebar = ({ open, onClose }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const storedData = localStorage.getItem("Ananya Enterprize-Users-Data");

  //Converting the fetched user details into JSON
  const userData = storedData ? JSON.parse(storedData) : {};
  const permissions = userData?.permissions;

  // Filter routes once to reduce repeated computation
  const filteredRoutes = routes.filter((route) => route.showInSidebar);

  const filteredWithPermissions = filteredRoutes.filter(
    (route) => permissions[route.permission]
  );

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const renderNavLink = (route) => (
    <NavLink
      to={`${route.layout}/${route.path}`}
      onClick={onClose}
      className={({ isActive }) =>
        `flex items-center px-6 py-3 text-base font-medium tracking-wide transition-all duration-200 ${
          isActive
            ? "rounded-lg bg-primary text-white shadow-md"
            : "rounded-lg text-gray-800 hover:bg-secondary hover:text-white"
        }`
      }
    >
      <div className="mr-3 h-6 w-6">{route.icon}</div>
      <span>{route.name}</span>
    </NavLink>
  );

  const renderDropdown = (route) => (
    <div>
      <button
        onClick={() => toggleDropdown(route.name)}
        className="flex w-full items-center justify-between rounded-lg px-6 py-3 text-base font-medium text-gray-800 transition-all duration-200 hover:bg-secondary hover:text-white focus:outline-none"
      >
        <div className="flex items-center">
          <div className="mr-3 h-6 w-6">{route.icon}</div>
          <span>{route.name}</span>
        </div>
        <svg
          className={`h-4 w-4 transform transition-transform ${
            openDropdown === route.name ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          ></path>
        </svg>
      </button>
      <div
        className="ml-12 mt-2 overflow-hidden"
        style={{
          maxHeight: openDropdown === route.name ? "200px" : "0",
          transition: "max-height 0.4s ease-out",
        }}
      >
        {route.children.map((child, childIndex) => (
          <NavLink
            key={childIndex}
            to={`${child.layout}/${child.path}`}
            className={({ isActive }) =>
              `mb-2 flex items-center px-6 py-3 text-sm font-medium tracking-wide transition-all duration-200 ${
                isActive
                  ? "rounded-lg bg-primary text-white"
                  : "rounded-lg text-gray-700 hover:bg-secondary hover:text-indigo-700"
              }`
            }
          >
            <span>{child.name}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className={`fixed left-0 top-0 z-50 h-full w-72 transform bg-white px-4 py-6 shadow-xl transition-transform ${
        open ? "translate-x-0" : "-translate-x-full"
      } xl:translate-x-0`}
    >
      <div className="mb-5 flex items-center justify-between">
        <div>
          <div className="flex w-full items-center justify-center">
            <img className="h-24 w-auto" src={logo} alt="logo" />
            <h1 className="text-xl font-bold tracking-wide text-primary">
              ANANYA ENTERPRISES
            </h1>
          </div>

          <hr className="w-full border-t-2 border-primary" />
        </div>
        <button
          className="text-gray-400 hover:text-primary focus:outline-none xl:hidden"
          onClick={onClose}
        >
          <HiX className="h-6 w-6" />
        </button>
      </div>

      <nav className="hide-scrollbar flex flex-col space-y-4 overflow-y-auto">
        {filteredWithPermissions.map((route, index) => (
          <div key={index} className="w-full">
            {!route.children ? renderNavLink(route) : renderDropdown(route)}
          </div>
        ))}
      </nav>

      <div className="flex-grow" />
    </div>
  );
};

export default AdminSidebar;
